import { render, staticRenderFns } from "./reviewInfo.vue?vue&type=template&id=33d61dfc&scoped=true&"
import script from "./reviewInfo.vue?vue&type=script&lang=js&"
export * from "./reviewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d61dfc",
  null
  
)

export default component.exports